<template>
  <header class="header">
    <a className="header__logo" href="https://www.mirrormedia.mg/">
      <img src="@/assets/logo.png" alt="鏡週刊 Mirror Media" />
    </a>
    <a className="img-title" href="https://www.mirrormedia.mg/campaigns/whisky2021/index.html">
      <img src="@/assets/title.png" alt="Life & Spirits" />
    </a>
  </header>
</template>

<script>
export default {
  name: 'UiTheHeader'
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  width: 100%;
  height: 60px;
  padding: 0 10px;
  background-color: #2C0405;
  @media screen and (min-width: 1024px) {
    padding: 0 24px;
  }
  &__logo {
    img {
      width: 42px;
      height: 42px;
    }
  }
  .img-title {
    position: absolute;
    top: 13px;
    left: 50%;
    width: 118px;
    transform: translateX(-50%) rotate(9deg);
    img {
      width: 100%;
    }
  }
}
</style>